export const COMMON_GET_CHANNELS_BEGIN = 'COMMON_GET_CHANNELS_BEGIN';
export const COMMON_GET_CHANNELS_SUCCESS = 'COMMON_GET_CHANNELS_SUCCESS';
export const COMMON_GET_CHANNELS_FAILURE = 'COMMON_GET_CHANNELS_FAILURE';
export const COMMON_GET_CHANNELS_DISMISS_ERROR = 'COMMON_GET_CHANNELS_DISMISS_ERROR';
export const COMMON_SET_PAGE_VIEW = 'COMMON_SET_PAGE_VIEW';
export const COMMON_SEARCH_CHANNELS_BEGIN = 'COMMON_SEARCH_CHANNELS_BEGIN';
export const COMMON_SEARCH_CHANNELS_SUCCESS = 'COMMON_SEARCH_CHANNELS_SUCCESS';
export const COMMON_SEARCH_NEW_CHANNELS_SUCCESS = 'COMMON_SEARCH_NEW_CHANNELS_SUCCESS';
export const COMMON_SEARCH_TOREPLY_CHANNELS_SUCCESS = 'COMMON_SEARCH_TOREPLY_CHANNELS_SUCCESS';
export const COMMON_SEARCH_CHANNELS_FAILURE = 'COMMON_SEARCH_CHANNELS_FAILURE';
export const COMMON_SEARCH_CHANNELS_DISMISS_ERROR = 'COMMON_SEARCH_CHANNELS_DISMISS_ERROR';
export const COMMON_SEARCH_CHANNELS_ADD_CHANNEL = 'COMMON_SEARCH_CHANNELS_ADD_CHANNEL';
export const COMMON_SEARCH_CHANNELS_CLEAR = 'COMMON_SEARCH_CHANNELS_CLEAR';
export const COMMON_SEARCH_CHANNELSV2_BEGIN = 'COMMON_SEARCH_CHANNELSV2_BEGIN';
export const COMMON_SEARCH_CHANNELSV2_SUCCESS = 'COMMON_SEARCH_CHANNELSV2_SUCCESS';
export const COMMON_SEARCH_CHANNELSV2_FAILURE = 'COMMON_SEARCH_CHANNELSV2_FAILURE';
export const COMMON_SEARCH_CHANNELSV2_DISMISS_ERROR = 'COMMON_SEARCH_CHANNELSV2_DISMISS_ERROR';
export const COMMON_SEARCH_CHANNELSV2_CLEAR = 'COMMON_SEARCH_CHANNELSV2_CLEAR';
export const COMMON_SIDEBAR_UPDATE_UNREAD = 'COMMON_SIDEBAR_UPDATE_UNREAD';
export const COMMON_SIDEBAR_RESET_UNREAD = 'COMMON_SIDEBAR_RESET_UNREAD';
export const COMMON_CONNECT_CHAT_MENU_SOCKET_BEGIN = 'COMMON_CONNECT_CHAT_MENU_SOCKET_BEGIN';
export const COMMON_CONNECT_CHAT_MENU_SOCKET_SUCCESS = 'COMMON_CONNECT_CHAT_MENU_SOCKET_SUCCESS';
export const COMMON_USERS_JOINED = 'COMMON_USERS_JOINED';
export const COMMON_USERS_LEFT = 'COMMON_USERS_LEFT';
export const COMMON_SIDEBAR_UPDATE = 'COMMON_SIDEBAR_UPDATE';
export const COMMON_SIDEBAR_USER_STATUS_UPDATE = 'COMMON_SIDEBAR_USER_STATUS_UPDATE';
export const COMMON_MOVE_USER_TODAY = 'COMMON_MOVE_USER_TODAY';
export const COMMON_SET_NOTIFICATION = 'COMMON_SET_NOTIFICATION';
export const COMMON_UNSET_NOTIFICATION = 'COMMON_UNSET_NOTIFICATION';
export const COMMON_SET_STATUS = 'COMMON_SET_STATUS';
export const COMMON_SET_SOCKET_CONNECTION = 'COMMON_SET_SOCKET_CONNECTION';
export const COMMON_SET_UNREAD_MESSAGE = 'COMMON_SET_UNREAD_MESSAGE';
export const COMMON_UNSET_UNREAD_MESSAGE = 'COMMON_UNSET_UNREAD_MESSAGE';
export const COMMON_GET_NOTIFICATIONS_BEGIN = 'COMMON_GET_NOTIFICATIONS_BEGIN';
export const COMMON_GET_NOTIFICATIONS_SUCCESS = 'COMMON_GET_NOTIFICATIONS_SUCCESS';
export const COMMON_GET_NOTIFICATIONS_FAILURE = 'COMMON_GET_NOTIFICATIONS_FAILURE';
export const COMMON_GET_NOTIFICATIONS_DISMISS_ERROR = 'COMMON_GET_NOTIFICATIONS_DISMISS_ERROR';
export const COMMON_ADD_NOTIFICATION = 'COMMON_ADD_NOTIFICATION';
export const COMMON_SET_CHANNEL_RELATION = 'COMMON_SET_CHANNEL_RELATION';
export const COMMON_SET_CHANNEL_INFO = 'COMMON_SET_CHANNEL_INFO';
export const COMMON_SET_WHATSAPP_CHANNEL_INFO = 'COMMON_SET_WHATSAPP_CHANNEL_INFO';
export const COMMON_SET_TRACKED_IDS = 'COMMON_SET_TRACKED_IDS';
export const COMMON_REMOVE_TRACKED_IDS = 'COMMON_REMOVE_TRACKED_IDS';
export const COMMON_SET_SIDEBAR_FILTER_PARAMS = 'COMMON_SET_SIDEBAR_FILTER_PARAMS';
export const COMMON_SET_TO_REPLY_BEGIN = 'COMMON_SET_TO_REPLY_BEGIN';
export const COMMON_SET_TO_REPLY_SUCCESS = 'COMMON_SET_TO_REPLY_SUCCESS';
export const COMMON_SET_TO_REPLY_FAILURE = 'COMMON_SET_TO_REPLY_FAILURE';
export const COMMON_SET_TO_REPLY_DISMISS_ERROR = 'COMMON_SET_TO_REPLY_DISMISS_ERROR';
export const COMMON_RESET_NOTIFICATIONS_BEGIN = 'COMMON_RESET_NOTIFICATIONS_BEGIN';
export const COMMON_RESET_NOTIFICATIONS_SUCCESS = 'COMMON_RESET_NOTIFICATIONS_SUCCESS';
export const COMMON_RESET_NOTIFICATIONS_FAILURE = 'COMMON_RESET_NOTIFICATIONS_FAILURE';
export const COMMON_RESET_NOTIFICATIONS_DISMISS_ERROR = 'COMMON_RESET_NOTIFICATIONS_DISMISS_ERROR';
export const COMMON_TOGGLE_SIDEBAR = 'COMMON_TOGGLE_SIDEBAR';
export const COMMON_GET_CHANNEL_BEGIN = 'COMMON_GET_CHANNEL_BEGIN';
export const COMMON_GET_CHANNEL_SUCCESS = 'COMMON_GET_CHANNEL_SUCCESS';
export const COMMON_GET_CHANNEL_FAILURE = 'COMMON_GET_CHANNEL_FAILURE';
export const COMMON_GET_CHANNEL_DISMISS_ERROR = 'COMMON_GET_CHANNEL_DISMISS_ERROR';
export const COMMON_GET_USER_CHANNEL_BEGIN = 'COMMON_GET_USER_CHANNEL_BEGIN';
export const COMMON_GET_USER_CHANNEL_SUCCESS = 'COMMON_GET_USER_CHANNEL_SUCCESS';
export const COMMON_GET_USER_CHANNEL_FAILURE = 'COMMON_GET_USER_CHANNEL_FAILURE';
export const COMMON_GET_USER_CHANNEL_DISMISS_ERROR = 'COMMON_GET_USER_CHANNEL_DISMISS_ERROR';
export const COMMON_UPDATE_FILTER_PARAMS = 'COMMON_UPDATE_FILTER_PARAMS';
export const COMMON_UPDATE_USERS = 'COMMON_UPDATE_USERS';
export const COMMON_GET_BROADCASTS_BEGIN = 'COMMON_GET_BROADCASTS_BEGIN';
export const COMMON_GET_BROADCASTS_SUCCESS = 'COMMON_GET_BROADCASTS_SUCCESS';
export const COMMON_GET_BROADCASTS_FAILURE = 'COMMON_GET_BROADCASTS_FAILURE';
export const COMMON_GET_BROADCASTS_DISMISS_ERROR = 'COMMON_GET_BROADCASTS_DISMISS_ERROR';
export const COMMON_TOGGLE_BROADCAST = 'COMMON_TOGGLE_BROADCAST';
export const COMMON_GET_BROADCAST_USERS_BEGIN = 'COMMON_GET_BROADCAST_USERS_BEGIN';
export const COMMON_GET_BROADCAST_USERS_SUCCESS = 'COMMON_GET_BROADCAST_USERS_SUCCESS';
export const COMMON_GET_BROADCAST_USERS_FAILURE = 'COMMON_GET_BROADCAST_USERS_FAILURE';
export const COMMON_GET_BROADCAST_USERS_DISMISS_ERROR = 'COMMON_GET_BROADCAST_USERS_DISMISS_ERROR';
export const COMMON_BROADCAST_CHANNELS_CLEAR = 'COMMON_BROADCAST_CHANNELS_CLEAR';
export const COMMON_CREATE_BROADCAST_BEGIN = 'COMMON_CREATE_BROADCAST_BEGIN';
export const COMMON_CREATE_BROADCAST_SUCCESS = 'COMMON_CREATE_BROADCAST_SUCCESS';
export const COMMON_CREATE_BROADCAST_FAILURE = 'COMMON_CREATE_BROADCAST_FAILURE';
export const COMMON_CREATE_BROADCAST_DISMISS_ERROR = 'COMMON_CREATE_BROADCAST_DISMISS_ERROR';
export const COMMON_SET_CURRENT_BROADCAST = 'COMMON_SET_CURRENT_BROADCAST';
export const COMMON_DELETE_BROADCAST_BEGIN = 'COMMON_DELETE_BROADCAST_BEGIN';
export const COMMON_DELETE_BROADCAST_SUCCESS = 'COMMON_DELETE_BROADCAST_SUCCESS';
export const COMMON_DELETE_BROADCAST_FAILURE = 'COMMON_DELETE_BROADCAST_FAILURE';
export const COMMON_DELETE_BROADCAST_DISMISS_ERROR = 'COMMON_DELETE_BROADCAST_DISMISS_ERROR';
export const COMMON_GET_CHANNEL_COUNT_BEGIN = 'COMMON_GET_CHANNEL_COUNT_BEGIN';
export const COMMON_GET_CHANNEL_COUNT_SUCCESS = 'COMMON_GET_CHANNEL_COUNT_SUCCESS';
export const COMMON_GET_CHANNEL_COUNT_FAILURE = 'COMMON_GET_CHANNEL_COUNT_FAILURE';
export const COMMON_GET_CHANNEL_COUNT_DISMISS_ERROR = 'COMMON_GET_CHANNEL_COUNT_DISMISS_ERROR';
export const COMMON_GET_SUPPORT_GROUPS_BEGIN = 'COMMON_GET_SUPPORT_GROUPS_BEGIN';
export const COMMON_GET_SUPPORT_GROUPS_SUCCESS = 'COMMON_GET_SUPPORT_GROUPS_SUCCESS';
export const COMMON_GET_SUPPORT_GROUPS_FAILURE = 'COMMON_GET_SUPPORT_GROUPS_FAILURE';
export const COMMON_GET_SUPPORT_GROUPS_DISMISS_ERROR = 'COMMON_GET_SUPPORT_GROUPS_DISMISS_ERROR';
export const COMMON_GET_NEW_USERS_BEGIN = 'COMMON_GET_NEW_USERS_BEGIN';
export const COMMON_GET_NEW_USERS_SUCCESS = 'COMMON_GET_NEW_USERS_SUCCESS';
export const COMMON_GET_NEW_USERS_FAILURE = 'COMMON_GET_NEW_USERS_FAILURE';
export const COMMON_GET_NEW_USERS_DISMISS_ERROR = 'COMMON_GET_NEW_USERS_DISMISS_ERROR';
export const COMMON_UPDATE_NEW_USERS = 'COMMON_UPDATE_NEW_USERS';
export const COMMON_GET_RECENTLY_REASSIGNED_USERS_BEGIN =
  'COMMON_GET_RECENTLY_REASSIGNED_USERS_BEGIN';
export const COMMON_GET_RECENTLY_REASSIGNED_USERS_SUCCESS =
  'COMMON_GET_RECENTLY_REASSIGNED_USERS_SUCCESS';
export const COMMON_GET_RECENTLY_REASSIGNED_USERS_FAILURE =
  'COMMON_GET_RECENTLY_REASSIGNED_USERS_FAILURE';
export const COMMON_GET_RECENTLY_REASSIGNED_USERS_DISMISS_ERROR =
  'COMMON_GET_RECENTLY_REASSIGNED_USERS_DISMISS_ERROR';
export const COMMON_UPDATE_RECENTLY_REASSIGNED_USERS = 'COMMON_UPDATE_RECENTLY_REASSIGNED_USERS';
export const COMMON_GET_USER_CHANNEL_COUNT_BEGIN = 'COMMON_GET_USER_CHANNEL_COUNT_BEGIN';
export const COMMON_GET_USER_CHANNEL_COUNT_SUCCESS = 'COMMON_GET_USER_CHANNEL_COUNT_SUCCESS';
export const COMMON_GET_USER_CHANNEL_COUNT_FAILURE = 'COMMON_GET_USER_CHANNEL_COUNT_FAILURE';
export const COMMON_GET_USER_CHANNEL_COUNT_DISMISS_ERROR =
  'COMMON_GET_USER_CHANNEL_COUNT_DISMISS_ERROR';
export const COMMON_GET_GROUP_CHANNEL_COUNT_BEGIN = 'COMMON_GET_GROUP_CHANNEL_COUNT_BEGIN';
export const COMMON_GET_GROUP_CHANNEL_COUNT_SUCCESS = 'COMMON_GET_GROUP_CHANNEL_COUNT_SUCCESS';
export const COMMON_GET_GROUP_CHANNEL_COUNT_FAILURE = 'COMMON_GET_GROUP_CHANNEL_COUNT_FAILURE';
export const COMMON_GET_GROUP_CHANNEL_COUNT_DISMISS_ERROR =
  'COMMON_GET_GROUP_CHANNEL_COUNT_DISMISS_ERROR';
export const COMMON_GET_SPONSORS_LIST_BEGIN = 'COMMON_GET_SPONSORS_LIST_BEGIN';
export const COMMON_GET_SPONSORS_LIST_SUCCESS = 'COMMON_GET_SPONSORS_LIST_SUCCESS';
export const COMMON_GET_SPONSORS_LIST_FAILURE = 'COMMON_GET_SPONSORS_LIST_FAILURE';
export const COMMON_GET_SPONSORS_LIST_DISMISS_ERROR = 'COMMON_GET_SPONSORS_LIST_DISMISS_ERROR';
export const COMMON_UNSET_UNREAD_MESSAGE_BEGIN = 'COMMON_UNSET_UNREAD_MESSAGE_BEGIN';
export const COMMON_UNSET_UNREAD_MESSAGE_SUCCESS = 'COMMON_UNSET_UNREAD_MESSAGE_SUCCESS';
export const COMMON_UNSET_UNREAD_MESSAGE_FAILURE = 'COMMON_UNSET_UNREAD_MESSAGE_FAILURE';
export const COMMON_UNSET_UNREAD_MESSAGE_DISMISS_ERROR =
  'COMMON_UNSET_UNREAD_MESSAGE_DISMISS_ERROR';
export const COMMON_GET_USER_FROM_CHANNEL_ID_BEGIN = 'COMMON_GET_USER_FROM_CHANNEL_ID_BEGIN';
export const COMMON_GET_USER_FROM_CHANNEL_ID_SUCCESS = 'COMMON_GET_USER_FROM_CHANNEL_ID_SUCCESS';
export const COMMON_GET_USER_FROM_CHANNEL_ID_FAILURE = 'COMMON_GET_USER_FROM_CHANNEL_ID_FAILURE';
export const COMMON_GET_USER_FROM_CHANNEL_ID_DISMISS_ERROR =
  'COMMON_GET_USER_FROM_CHANNEL_ID_DISMISS_ERROR';
export const COMMON_GET_BROADCAST_DETAILS_BEGIN = 'COMMON_GET_BROADCAST_DETAILS_BEGIN';
export const COMMON_GET_BROADCAST_DETAILS_SUCCESS = 'COMMON_GET_BROADCAST_DETAILS_SUCCESS';
export const COMMON_GET_BROADCAST_DETAILS_FAILURE = 'COMMON_GET_BROADCAST_DETAILS_FAILURE';
export const COMMON_GET_BROADCAST_DETAILS_DISMISS_ERROR =
  'COMMON_GET_BROADCAST_DETAILS_DISMISS_ERROR';
export const COMMON_RESEND_FAILED_BROADCAST_BEGIN = 'COMMON_RESEND_FAILED_BROADCAST_BEGIN';
export const COMMON_RESEND_FAILED_BROADCAST_SUCCESS = 'COMMON_RESEND_FAILED_BROADCAST_SUCCESS';
export const COMMON_RESEND_FAILED_BROADCAST_FAILURE = 'COMMON_RESEND_FAILED_BROADCAST_FAILURE';
export const COMMON_RESEND_FAILED_BROADCAST_DISMISS_ERROR =
  'COMMON_RESEND_FAILED_BROADCAST_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js